(function () {
  // ハンバーガードロワー(header-sidebar)を開閉したときのフェード/スライド演出、
  // および x-header（ロゴ/ナビ項目）がページ読み込み時に「上からふわっと」
  // 順番に表示される演出を止め、即座に完成形で見えるようにする。
  // CSS の transition-duration:0 !important だけでは Web Animations API
  // (element.animate()) で作られたアニメーションは止まらないため、
  // document.getAnimations() で対象要素配下（shadow DOM 含む）の
  // アニメーションを見つけ次第 finish() して終端状態へ即座に飛ばす。
  var sidebar = document.getElementById('sidebar-menu');
  var header = document.querySelector('x-header');

  function killDrawerAnimations() {
    if (!document.getAnimations) return;
    document.getAnimations().forEach(function (a) {
      var el = a.effect && a.effect.target;
      if (!el) return;
      if (sidebar && sidebar.contains && sidebar.contains(el)) { a.finish(); return; }
      if (header && header.contains && header.contains(el)) { a.finish(); return; }
      if (el.closest && el.closest('.header-sidebar, #sidebar-menu, x-header')) { a.finish(); }
    });
  }

  if (sidebar) {
    new MutationObserver(killDrawerAnimations).observe(sidebar, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['style', 'hidden', 'open', 'aria-expanded', 'aria-activedescendant', 'class']
    });
  }
  if (header) {
    new MutationObserver(killDrawerAnimations).observe(header, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['style', 'hidden', 'open', 'class']
    });
  }

  // ページ読み込み時（x-header の初回表示アニメーション対策）: できるだけ早いタイミングから
  // 何度もリトライして、演出が開始した瞬間に終端まで飛ばす。フォント/画像読み込み後に
  // 遅れて発火するケースにも備え、数秒間は間隔を空けて監視し続ける。
  killDrawerAnimations();
  requestAnimationFrame(killDrawerAnimations);
  requestAnimationFrame(function () { requestAnimationFrame(killDrawerAnimations); });
  [0, 50, 100, 200, 400, 800, 1200, 1600, 2000, 2500, 3000, 4000, 5000].forEach(function (ms) {
    setTimeout(killDrawerAnimations, ms);
  });
  document.addEventListener('DOMContentLoaded', killDrawerAnimations);
  window.addEventListener('load', function () {
    killDrawerAnimations();
    setTimeout(killDrawerAnimations, 300);
    setTimeout(killDrawerAnimations, 1000);
  });
  document.fonts && document.fonts.ready && document.fonts.ready.then(killDrawerAnimations);

  // click より早く発火する pointerdown/touchstart でも仕掛けておく（実機タップ対策）
  ['pointerdown', 'touchstart', 'click'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      killDrawerAnimations();
      requestAnimationFrame(killDrawerAnimations);
      requestAnimationFrame(function () { requestAnimationFrame(killDrawerAnimations); });
      setTimeout(killDrawerAnimations, 0);
      setTimeout(killDrawerAnimations, 50);
    }, true);
  });
})();
